import React from 'react';
import { Box } from '@withjoy/joykit';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useTranslation } from '@shared/core';
import { useCountdown } from '@shared/hooks/useCountdown';
import { useEventInfo } from '@shared/utils/eventInfo';

type CountDownBannerExperimentProps = Readonly<{
  dateMs: number;
}>;

export const CountDownBannerExperiment = ({ dateMs }: CountDownBannerExperimentProps) => {
  const { countDown } = useCountdown(dateMs);
  const [showBanner] = useIsFeatureEnabled('guestGuideCountDownBannerV2');
  const { t } = useTranslation('guestGuide');
  const { eventInfo } = useEventInfo();
  const eventType = eventInfo?.eventType;

  if (!showBanner) {
    return null;
  }
  const time = () => (
    <Box
      as="span"
      typographyVariant={'hed4'}
    >
      {t('countDownBannerDays')({ days: countDown.days })}
    </Box>
  );

  const messageTranslation = eventType === 'wedding' ? t('countDownBannerWedding') : t('countDownBannerEvent');

  const message = messageTranslation({
    time: time,
  });

  return showBanner ? (
    <Box
      typographyVariant={'body2'}
      marginBottom={4}
    >
      {message}
    </Box>
  ) : null;
};
